import { DayStyleConfig, defaultDayStyle } from './Calendar/type';
import { defaultWeekStyleConfig, WeekStyleConfig } from './Week/type';

export type DatePickerStyleConfig = {
  bgColor: string;
  color: string;
  weekStyle: Partial<WeekStyleConfig>;
  dayStyle: Partial<DayStyleConfig>;
};

export const defaultDatePickerStyle: DatePickerStyleConfig = {
  bgColor: 'bg.surface',
  color: 'black',
  weekStyle: defaultWeekStyleConfig,
  dayStyle: defaultDayStyle,
};
